<template>
  <div class="contacts">
    <HeroText
      :heroH1="''"
      :heroH2="currentPage.fields.title"
      :heroP="currentPage.fields.intro"
      :internalPage="true"/>
    <ContactsForm />
    <glaxiFooter />
  </div>
</template>

<script>

import HeroText from '@/components/HeroText/HeroText.vue'
import ContactsForm from '@/components/ContactsForm/ContactsForm.vue'
import GlaxiFooter from '@/components/GlaxiFooter/GlaxiFooter.vue'

import { mapGetters } from 'vuex'

export default {
  name: 'Contacts',
  components: {
    HeroText,
    ContactsForm,
    GlaxiFooter
  },
  props: {
    currentPage: {
      type: Object,
      required: false
    }
  },
  computed: {
    ...mapGetters([
      'lang'
    ])
  }
}
</script>

<style lang="scss">
  @import "./contacts.scss";
</style>
